module.exports = __webpack_public_path__ + "cdf6a6777401535a4e23095a01b43a27.png";